/*
 * @Author: lvbl
 * @Date: 2021-08-18 15:21:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecp-vue\src\store\module\nportal.js
 */

import api from "@/api/nportal.js";

const home = {
    state: {
        currentPage: 0, //分页器当前页
        metaTitle: "", //页面标题
        stationPath: "", //当前的站点路径
        stationTheme: "", //当前站点的主题色
        stationBackpic: "", //当前站点首部背景图
        siteType: "", //当前站点的站点类型 ，01为市局
        siteUuid: "" //当前站点主键
    },
    mutations: {
        SET_META_TITLE: (state, title) => {
            state.metaTitle = title
        },
        SET_STATIONPATH: (state, path) => {
            state.stationPath = path
        },
        SET_CURRENTPAGE: (state, page) => {
            state.currentPage = page
        },
        SET_STATIONTHEME: (state, theme) => {
            state.stationTheme = theme
        },
        SET_STATIONBACKPIC: (state, backpic) => {
            state.stationBackpic = backpic
        },
        SET_SITE_TYPE: (state, siteType) => {
            state.siteType = siteType
        },
        SET_SITE_UUID: (state, siteUuid) => {
            state.siteUuid = siteUuid
        },
        SET_LOGOSIZE: (state, logoSize) => {
            state.logoSize = logoSize
        }
    },

    actions: {
        //获取站点路径
        GetPath({ commit }, path) {
            return new Promise((resolve, reject) => {
                commit('SET_STATIONPATH', path)
                resolve()
            })
        },
        //获取站点主题色,获取首部背景图
        GetTheme({ commit }, path) {
            return new Promise((resolve, reject) => {
                api.reqSiteInfo(path).then(res => {
                    if (res.result) {
                        let resObj = res.result;
                        if (resObj.theme_type)
                            commit('SET_STATIONTHEME', resObj.theme_type)
                        else {
                            commit('SET_STATIONTHEME', "1")
                        }
                        if (resObj.header_logo_uuid) {
                            commit('SET_STATIONBACKPIC', resObj.header_logo_uuid)
                            if (resObj.header_height && resObj.header_width) {
                                let logoSize = JSON.stringify({ w: resObj.header_width, h: resObj.header_height });
                                commit('SET_LOGOSIZE', logoSize);
                            }
                        }
                        //01为市局站点（主站点）
                        if (resObj.site_type) {
                            commit('SET_SITE_TYPE', resObj.site_type)
                        }
                        if (resObj.site_uuid) {
                            commit('SET_SITE_UUID', resObj.site_uuid)
                        }
                        resolve()
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        /**
         * 设置网页title
         * @param commit
         * @param title
         * @constructor
         */
        SetMeta({ commit }, title) {
            return new Promise((resolve) => {
                commit('SET_META_TITLE', title)
                resolve()
            })
        },

        /**
         * 记录分页器当前页面数值
         * @param commit
         * @param pageNum
         * @constructor
         */
        SetCurrentPage({ commit }, pageNum) {
            return new Promise((resolve) => {
                commit('SET_CURRENTPAGE', pageNum)
                resolve()
            })
        },
    }
}

export default home